import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import MillerWritingCenter from './pages/MillerWritingCenter';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/miller-writing-center" element={<MillerWritingCenter />} />
      </Routes>
      <Footer />
  </Router>
  );
}

export default App;
